var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import styled from 'styled-components';
var CustomArrow = function (props) {
    var className = props.className, style = props.style, onClick = props.onClick, children = props.children, arrow = props.arrow;
    return arrow === 'prev' ? (React.createElement(NavigateBeforeIcon, { className: className, style: style, onClick: onClick, color: "disabled" })) : (React.createElement(NavigateNextIcon, { className: className, style: style, onClick: onClick, color: "disabled" }));
    // >{children}</StyleArrow>
};
var arrowSize = 50;
var StyleArrow = styled(CustomArrow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n  height: 100% !important;\n  ", "\n  ", "\n    font-size: ", "px !important;\n  :hover {\n    color: rgba(0, 0, 0, 0.56);\n    font-size: ", "px;\n  }\n"], ["\n  z-index: 1;\n  height: 100% !important;\n  ", "\n  ", "\n    font-size: ", "px !important;\n  :hover {\n    color: rgba(0, 0, 0, 0.56);\n    font-size: ", "px;\n  }\n"])), function (props) { return props.arrow === 'prev' && 'left: 0;'; }, function (props) { return props.arrow === 'next' && 'right: 0;'; }, arrowSize, arrowSize + 10);
var StyleUl = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return props.dotsIn && 'bottom: 10px;'; });
var Carousel = function (props) {
    var sliderContent = props.sliderContent, dotsIn = props.dotsIn, arrowsRWD = props.arrowsRWD, other = __rest(props, ["sliderContent", "dotsIn", "arrowsRWD"]);
    // const [isSm, setIsSm] = useState(window.innerWidth <= 600)
    // useEffect(() => {
    //     console.log("useEffect")
    //     const updateIsUm = () => setIsSm(window.innerWidth <= 600)
    //     window.addEventListener("resize", updateIsUm);
    //     return () => window.removeEventListener("resize", updateIsUm);
    // }, []);
    return (React.createElement("div", { style: !dotsIn ? { marginBottom: '50px' } : {} },
        React.createElement(Slider
        // arrows={arrowsRWD && isSm ? false : true}
        , __assign({ 
            // arrows={arrowsRWD && isSm ? false : true}
            dots: true, infinite: true, autoplaySpeed: 3000, slidesToShow: 1, slidesToScroll: 1, prevArrow: React.createElement(StyleArrow, { arrow: "prev" }), nextArrow: React.createElement(StyleArrow, { arrow: "next" }), appendDots: function (dots) { return React.createElement(StyleUl, { dotsIn: dotsIn }, dots); } }, other), sliderContent.map(function (obj, idx) { return (React.createElement("div", { key: idx }, obj)); }))));
};
export default Carousel;
var templateObject_1, templateObject_2;
